<template>
  <p-edit v-if="$hasPermission('workflows.read')" />
  <p-not-found v-else />
</template>

<script>
import NotFound from './../components/NotFound.vue';
import EditWorkflow from '../components/workflows/EditWorkflow';

export default {
  components: {
    'p-edit': EditWorkflow,
    'p-not-found': NotFound
  }
};
</script>
